module.exports = __webpack_public_path__ + "img/icon_landing1.ff1a352f.jpeg";